import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 55px;
  height: 55px;
  margin-bottom: 20px;
  padding-right: 20px;
  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 55px;
    min-height: 55px;
    height: 55px;
    max-height: 55px;
    border-radius: 50px;
    background-color: ${({ theme }) => theme.colors.secondary40};
    cursor: pointer;
    svg {
      color: ${({ theme }) => theme.colors.primary};
      width: 24px;
      height: 24px;
    }
  }
  .text {
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: 13px;
    overflow: hidden;
    height: 55px;
    span {
      color: ${({ theme }) => theme.colors.secondary70};
      white-space: nowrap;
      margin-right: 5px;
    }
    font-size: 16px;
    color: ${({ theme }) => theme.colors.secondary100};
    div {
      display: contents;
      position: relative;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 55px;
    }
  }
`;
